class PromiseCache {
  private _cache: Record<string, Promise<unknown>> = {};

  public cached<T extends Promise<unknown>>(name: string, data: unknown, getPromise: () => T): T {
    const key = `${name}-${JSON.stringify(data)}`;

    if (!this._cache[key]) {
      this._cache[key] = getPromise().finally(() => {
        delete this._cache[key];
      });
    }

    return this._cache[key] as T;
  }
}

export const requestsCache = new PromiseCache();
